module.exports = __webpack_public_path__ + "img/mbp-16-fedora.f1acb7d6.webp";